import unassignedAvatar from 'assets/img/Avatar.png';
import { colors } from 'utils/colors';

export const resourceTypes = {
  teacher: 'teacher',
  location: 'location',
};

export const eventTypes = {
  private: 'private',
  group: 'group classes',
  internal: 'internal',
  request: 'request',
  unavailable: 'unavailable',
};

export const unassignedTeacher = {
  id: -1,
  first_name: 'Unassigned',
  last_name: '',
  full_name: 'Unassigned',
  image: unassignedAvatar,
};

export const unassignedRoom = {
  id: -1,
  name: 'Unassigned',
  roomName: 'Unassigned',
};

export const eventColors = {
  [eventTypes.group]: colors.newViolin,
  [eventTypes.private]: colors.newOrange,
  [eventTypes.internal]: colors.newGreen,
  [eventTypes.request]: colors.gray25,
  [eventTypes.unavailable]: colors.newBlueLight,
};
